<template>
  <div class="father">
    <div class="docfb-father">
      <tablecard></tablecard>
    </div>
  </div>
</template>
<script>
import tablecard from "./components/tablecard.vue";
export default {
  components: { tablecard }
};
</script>

<style scoped>
.docfb-father {
  width: 100%;
  height: 100%;
  background-color: #eff4ff;
}
</style>
